import {
  AfterViewInit,
  Component,
  ElementRef,
  forwardRef,
  Input,
  ViewChild,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { IntlTelInputComponent } from 'intl-tel-input-ng';
import { NgIf } from '@angular/common';

@Component({
  selector: 'ui-phone-input',
  templateUrl: './ui-phone-input.component.html',
  styleUrls: ['./ui-phone-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiPhoneInputComponent),
      multi: true,
    },
  ],
  imports: [FormsModule, IntlTelInputComponent, NgIf],
})
export class UiPhoneInputComponent
  implements AfterViewInit, ControlValueAccessor
{
  @ViewChild('tell')
  public telInput?: IntlTelInputComponent;
  @Input()
  public isVerified = false;
  @Input()
  public inputClass = '';

  public get phoneInputOptions(): Record<string, unknown> {
    return {
      preferredCountries: ['us'],
      showSelectedDialCode: true,
      dropdownContainer:
        typeof document !== 'undefined' ? document.body : undefined,
    };
  }

  constructor(private elementRef: ElementRef) {}

  public setDisabledState(): void {
    // Intentionally left blank; ControlValueAccessor contract requires this method.
  }

  public value = '';

  public onChange: (val: string) => void = () => undefined;
  public onTouched: () => void = () => undefined;

  // This is the initial value set to our component
  public writeValue(value: string | null): void {
    this.value = value ?? '';
    if (this.value && this.telInput) {
      this.telInput.phoneNumber = this.value;
    }
  }

  public ngAfterViewInit(): void {
    if (this.value && this.telInput) {
      this.telInput.phoneNumber = this.value;
    }

    this.setupDropdownPositioning();
  }

  private setupDropdownPositioning(): void {
    setTimeout(() => {
      const rootElement = this.elementRef.nativeElement as HTMLElement;
      const itiElement: HTMLElement | null = rootElement.querySelector('.iti');
      if (itiElement) {
        const dropdown: HTMLElement | null = itiElement.querySelector(
          '.iti__dropdown-content',
        );
        if (dropdown) {
          const flagContainer = itiElement.querySelector('.iti__selected-flag');
          if (flagContainer) {
            flagContainer.addEventListener('click', () => {
              setTimeout(() => this.positionDropdown(itiElement, dropdown), 10);
            });
          }
        }
      }
    }, 100);
  }

  private positionDropdown(
    itiElement: HTMLElement,
    dropdown: HTMLElement,
  ): void {
    const rect = itiElement.getBoundingClientRect();
    const dropdownHeight = 200;
    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
      dropdown.classList.add('iti__dropdown-content--above');
    } else {
      dropdown.classList.remove('iti__dropdown-content--above');
    }
  }

  public registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  public updateValue(): void {
    if (this.value) {
      this.onChange(this.value);
      this.onTouched();
    }
  }

  public get valid(): boolean {
    return !!this.value;
  }
}
